<template>
  <div>
    <h3 class="text-lg font-medium mb-4">Delete media item</h3>
    <BaseVeeForm :action="deleteMediaItem" @success="$emit('deleted')">
      <!-- formProps
        isIdle, isPending, isResolved, isRejected, invalid
        errors, submit
      -->
      <template #default="formProps">
        <p class="mb-2">This action cannot be undone. Any related resources will be detached.</p>
        <BaseButton primary :disabled="disabled || formProps.isPending"> Delete </BaseButton>
      </template>
    </BaseVeeForm>
  </div>
</template>

<script>
import { mediaLibraryMediaClient } from '@/api/clients/admin';

export default {
  props: {
    mediaItem: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    async deleteMediaItem() {
      try {
        this.$emit('deleting');
        await mediaLibraryMediaClient.destroy(this.mediaItem.id);

        this.$emit('deleted');
      } catch (error) {
        //
      } finally {
        this.$emit('finished');
      }
    },
  },
};
</script>
